<template>
  <div>
    <v-container fluid fill-height class="pa-0">
      <v-hover v-slot:default="{ hover }">
        <v-carousel
          :cycle="hover ? false : true"
          hide-delimiters
          :show-arrows="false"
          height="calc(95vh - 165px)"
          class="max-h70vh">
          <v-carousel-item
            v-for="(slide, i) in headerlist"
            :key="i"
            :lazy-src="require('../assets/default.jpg')"
            :src="slide.urlpic"
            class="max-h70vh">
            <v-container
              fill-height
              fluid
              pa-0 ma-0
              class="max-h70vh">
              <v-container class="pa-0">
                <v-layout
                  fill-height>
                  <v-flex
                    xs12
                    :align-self-end="!$vuetify.breakpoint.smAndDown"
                    :align-self-center="$vuetify.breakpoint.smAndDown">
                    <v-card
                      tile
                      color="transparent"
                      flat>
                      <v-card-text class="background-trans-style">
                        <div>
                          <h1 class="white--text text-md-h2 mb-5 title-page">{{ $t('header.collaboration') }}</h1>
                          <h2 class="white--text text-md-h4 mb-5">
                            {{ $t('header.tagline') }}
                          </h2>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </v-hover>
    </v-container>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="12">
              <h2 class="text-md-h4 font-weight-bold sub-title-page">
                {{ $t('title.intpartner') }}
              </h2>
            </v-col>
            <v-col cols="12" md="6" class="text-md-justify">
              <div v-if="$i18n.locale === 'en'">
                <ul>
                  <li>Brunel University London, the UK: Collaborative Research in Renewable energy</li>
                  <li>Rajamangala University of Technology Phra Nakhon, Thailand: Research in Green Tourism</li>
                  <li>Keio University, Japan: Research in ground water capacity & water quality</li>
                  <li>TNO, Netherland: Master plan of renewable energy training center</li>
                  <li>SECO, Switzerland: Renewable energy skill development</li>
                </ul>
              </div>
              <div v-if="$i18n.locale === 'id'">
                <ul>
                  <li>Brunel University London, UK; Penelitian Kolaboratif dalam energi terbarukan</li>
                  <li>Rajamangala University of Technology Phra Nakhon, Thailand; Penelitian pada bidang Green Tourism</li>
                  <li>Keio University, Japan; Penelitian kapasitas air tanah & kualitas air</li>
                  <li>TNO, Netherland; Rencana Induk Pusat Pelatihan Energi Terbarukan</li>
                  <li>SECO, Switzerland; Pengembangan Keterampilan Energi Terbarukan</li>
                </ul>
              </div>
            </v-col>
            <v-col cols="12" md="1" v-show="!$vuetify.breakpoint.smAndDown">
              <!-- <v-divider vertical></v-divider> -->
            </v-col>
            <v-col cols="12" md="5">
              <v-row>
                <v-col cols="6" md="4">
                  <v-card
                    outline
                    class="my-0"
                    href="https://www.brunel.ac.uk/"
                    target="_blank">
                    <v-img
                      :src="require('../assets/com_brunel.jpg')"
                      class="white--text align-end"
                      height="70"
                      contain>
                    </v-img>
                  </v-card>
                </v-col>
                <v-col cols="6" md="4">
                  <v-card
                    outline
                    class="my-0"
                    href="https://www.eng.rmutt.ac.th/"
                    target="_blank">
                    <v-img
                      :src="require('../assets/com_RNUTM.png')"
                      class="white--text align-end"
                      height="70"
                      contain>
                    </v-img>
                  </v-card>
                </v-col>
                <v-col cols="6" md="4">
                  <v-card
                    outline
                    class="my-0"
                    href="https://www.keio.ac.jp/en/"
                    target="_blank">
                    <v-img
                      :src="require('../assets/com_keio.png')"
                      class="white--text align-end"
                      height="70"
                      contain>
                    </v-img>
                  </v-card>
                </v-col>
                <v-col cols="6" md="4">
                  <v-card
                    outline
                    class="my-0"
                    href="https://www.tno.nl/en/"
                    target="_blank">
                    <v-img
                      :src="require('../assets/com_TNO.png')"
                      class="white--text align-end"
                      height="70"
                      contain>
                    </v-img>
                  </v-card>
                </v-col>
                <v-col cols="6" md="4">
                  <v-card
                    outline
                    class="my-0"
                    href="https://www.seco.admin.ch/seco/en/home.html"
                    target="_blank">
                    <v-img
                      :src="require('../assets/com_SECO.jpg')"
                      class="white--text align-end"
                      height="70"
                      contain>
                    </v-img>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="12">
              <h2 class="text-md-h4 font-weight-bold sub-title-page">
                {{ $t('title.naspartner') }}
              </h2>
            </v-col>
            <v-col cols="12" md="6" class="text-justify">
              <div v-if="$i18n.locale === 'en'">
                <ul>
                  <li>Research & Development Agency of Bali Province: Research in renewable energy</li>
                  <li>District of Denpasar City: Research in renewable energy</li>
                  <li>PLN (National Electrical Company): Research in energy conservation</li>
                  <li>Indonesia Power: Research in renewable energy</li>
                  <li>The Ministry of Renewable Energy and Energy Conservation: Research in renewable energy</li>
                </ul>
              </div>
              <div v-if="$i18n.locale === 'id'">
                <ul>
                  <li>Badan Litbang Provinsi Bali; Riset Energi Terbarukan</li>
                  <li>Kota Denpasar; Riset Energi Terbarukan</li>
                  <li>PLN (Perusahaan Listrik Negara); Penelitian dalam konservasi energi</li>
                  <li>Indonesia Power; Riset Energi Terbarukan</li>
                  <li>Kementrian ESDM; Energi terbarukan</li>
                </ul>
              </div>
            </v-col>
            <v-col cols="12" md="1" v-show="!$vuetify.breakpoint.smAndDown">
              <!-- <v-divider vertical></v-divider> -->
            </v-col>
            <v-col cols="12" md="5">
              <v-row>
                <v-col cols="6" md="4">
                  <v-card
                    outline
                    class="my-0"
                    href="https://bari.baliprov.go.id/"
                    target="_blank">
                    <v-img
                      :src="require('../assets/com_balitbang.png')"
                      class="white--text align-end"
                      height="70"
                      contain>
                    </v-img>
                  </v-card>
                </v-col>
                <v-col cols="6" md="4">
                  <v-card
                    outline
                    class="my-0"
                    href="https://www.denpasarkota.go.id/"
                    target="_blank">
                    <v-img
                      :src="require('../assets/com_denpasar.png')"
                      class="white--text align-end"
                      height="70"
                      contain>
                    </v-img>
                  </v-card>
                </v-col>
                <v-col cols="6" md="4">
                  <v-card
                    outline
                    class="my-0"
                    href="https://portal.pln.co.id/"
                    target="_blank">
                    <v-img
                      :src="require('../assets/com_PLN.png')"
                      class="white--text align-end"
                      height="70"
                      contain>
                    </v-img>
                  </v-card>
                </v-col>
                <v-col cols="6" md="4">
                  <v-card
                    outline
                    class="my-0"
                    href="https://www.indonesiapower.co.id/id/Default.aspx"
                    target="_blank">
                    <v-img
                      :src="require('../assets/com_indoPower.png')"
                      class="white--text align-end"
                      height="70"
                      contain>
                    </v-img>
                  </v-card>
                </v-col>
                <v-col cols="6" md="4">
                  <v-card
                    outline
                    class="my-0"
                    href="https://www.esdm.go.id/"
                    target="_blank">
                    <v-img
                      :src="require('../assets/com_ESDM.png')"
                      class="white--text align-end"
                      height="70"
                      contain>
                    </v-img>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-container fluid fill-height class="py-10 min-height-pages bacground-maincolor">
      <v-container class="px-0 px-md-3">
        <v-row justify="center">
          <v-col cols="12" md="12">
            <v-row class="white--text">
              <v-col cols="12" md="12">
                <h2 class="text-md-h4 font-weight-bold sub-title-page" v-if="$i18n.locale === 'en'">
                  Collaboration Between<br>
                  PNB – Bali Provincial Government – MSDM ESDM
                </h2>
                <h2 class="text-md-h4 font-weight-bold sub-title-page" v-if="$i18n.locale === 'id'">
                  Kerjasama PNB – Pemprov Bali – MSDM ESDM
                </h2>
              </v-col>
              <v-col cols="12" md="12">
                <div class="font-weight-bold">
                  Wed, 7 Aug. 2019
                </div>
                <v-divider class="my-2" dark></v-divider>
                <p>
                  Recommendation from the Governor of Bali regarding the establishment of the Energy and Mining Polytechnic (PEP) in Bali (addressed to the Minister of Energy and Mineral Resources).
                </p>
              </v-col>
              <v-col cols="12" md="12">
                <div class="font-weight-bold">
                  Mon, 24 Feb. 2020 
                </div>
                <v-divider class="my-2" dark></v-divider>
                <p>
                  Meeting with Mr Kaban MSDM ESDM to discuss plans for cooperation in the development of an renewable energy education and training centre.
                </p>
              </v-col>
              <v-col cols="12" md="12">
                <div class="font-weight-bold">
                  Tue, 26 Feb. 2020
                </div>
                <v-divider class="my-2" dark></v-divider>
                <p>
                  Signing of a Memorandum of Understanding between the Head of BPSDM ESDM and PNB regarding HR development in the vocational sector in the energy and mineral resources sector.
                </p>
              </v-col>
              <v-col cols="12" md="12">
                <div class="font-weight-bold">
                  Tue, 26 Feb. 2020
                </div>
                <v-divider class="my-2" dark></v-divider>
                <p>
                  PNB sent a file requesting permission for the establishment of the RE D3 program to the Minister of Education and Culture (to date, the written response has yet to receive).
                </p>
              </v-col>
              <v-col cols="12" md="12">
                <div class="font-weight-bold">
                  Thu, 27 Feb. 2020
                </div>
                <v-divider class="my-2" dark></v-divider>
                <p>
                  Audience with the Governor of Bali to prepare for the establishment of an RE study program.
                </p>
              </v-col>
              <v-col cols="12" md="12">
                <div class="font-weight-bold">
                  Tue, 3 Mar. 2020
                </div>
                <v-divider class="my-2" dark></v-divider>
                <p>
                  Issued a letter of recommendation from the Governor of Bali regarding the establishment of the Study Program:
                </p>
                <ul>
                  <li>D3 Energy Conversion;</li>
                  <li>D3 Electrical Technology;</li>
                  <li>D3 Machine Maintenance;</li>
                  <li>D3 Mechatronics</li>
                </ul>
              </v-col>
              <v-col cols="12" md="12">
                <div class="font-weight-bold">
                  Fri, 6 Mar. 2020
                </div>
                <v-divider class="my-2" dark></v-divider>
                <p>
                  Signing of Memorandum of Understanding between PNB - PEM AKAMIGAS (already numbered, content has been discussed and mutually agreed upon, signed by the Director of PNB, original document is still in PEM AKAMIGAS).
                </p>
              </v-col>
              <v-col cols="12" md="12">
                <div class="font-weight-bold">
                  Fri, 5 Jun. 2020
                </div>
                <v-divider class="my-2" dark></v-divider>
                <p>
                  Audience with PLT Director General of Dictions to get follow-up directions for the application for permission to establish an RE Study Program.
                </p>
              </v-col>
              <v-col cols="12" md="12">
                <div class="font-weight-bold">
                  Academic year 2020-2021
                </div>
                <v-divider class="my-2" dark></v-divider>
                <p>
                  PNB-Pemprov Bali and PEM AKA MIGAS decided to open a Cooperation Class on RE concentration, while waiting for the progress of the application for permission to establish the RE Study Program.
                </p>
                <p>
                  In this academic year , we had received 1 Cooperation class - RE Concentration, an embryo of the RE Study Program which is temporarily embedded in the Electrical Engineering D3 Study Program. Number of students 2020-2021: 15 students.
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-divider></v-divider>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <h2 class="text-md-h4 font-weight-bold sub-title-page">
            {{ $t('title.newspartner') }}
          </h2>
        </v-col>
      </v-row>
      <v-row v-if="newslist.length">
        <v-col
          class="d-flex"
          cols="12"
          md="4"
          v-for="(news, i) in newslist"
          :key="i">
          <v-card
            class="d-flex flex-column w100">
            <v-img
              class="white--text align-end flex-grow-0 flex-shrink-1"
              height="225px"
              :src="news.urlpic">
            </v-img>
            <v-card-subtitle>
              <h1 class="title font-weight-bold mb-3">
                <router-link class="text-decoration-none text-ellipsis--2"
                  :title="news.judul_berita"
                  :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                  {{ news.judul_berita }}
                </router-link>
              </h1>
              <div class="d-flex">
                <v-chip
                  class="mr-1"
                  color="deep-orange"
                  small
                  dark
                  :title="news.tgl_berita">
                  <v-icon left small>
                    mdi-update
                  </v-icon>
                  <timeago :datetime="news.tgl_berita"></timeago>
                </v-chip>
                <v-chip
                  class="mr-1"
                  color="primary"
                  small
                  dark>
                  <v-icon left small>
                    mdi-alpha-c-circle
                  </v-icon>
                  {{ news.cat_berita }}
                </v-chip>
                <v-spacer></v-spacer>
                <ShareNetwork
                  network="facebook"
                  :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                  :title="news.judul_berita"
                  :description="news.prev_berita"
                  :quote="news.prev_berita"
                  hashtags="international,pnb,bali"
                  class="text-decoration-none d-inline mr-1">
                  <v-icon color="indigo">
                    mdi-facebook
                  </v-icon>
                </ShareNetwork>
                <ShareNetwork
                  network="whatsapp"
                  :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                  :title="news.judul_berita"
                  :description="news.prev_berita"
                  :quote="news.prev_berita"
                  hashtags="international,pnb,bali"
                  class="text-decoration-none d-inline mr-1">
                  <v-icon color="green">
                    mdi-whatsapp
                  </v-icon>
                </ShareNetwork>
              </div>
            </v-card-subtitle>
            <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
              <div v-html="news.prev_berita"></div>
            </v-card-text>
            <v-card-actions v-if="false">
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small
                :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn
            large
            :color="maincolor"
            dark
            :to="{ name: 'News', query: { type: 'berita', category: 'pengabdian' } }"
            exact>
            {{ $t('button.othernews') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!newslist.length">
        <v-col cols="12" md="12">
          <div class="grey--text my-2">
            Berita pada kategori ini tidak ditemukan.
          </div>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn
            large
            :color="maincolor"
            dark
            :to="{ name: 'News', query: { type: 'berita', category: 'kerjasama' } }"
            exact>
            {{ $t('button.othernews') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Collaboration',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    newslist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    paramberita: {
      search: '',
      limit: '',
      offset: '',
      lang: '',
      type: '',
      category: '',
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
    headerlist: [
      {
        id_berita: '',
        judul_berita: '',
        urlpic: require('./../assets/cov-collaboration.jpg'),
      },
    ],
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getBerita();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  watch: {
    '$i18n.locale'(val) {
      if (val) {
        // console.log(val);
        this.updateLanguage();
      }
    },
  },
  methods: {
    getRouteUrl(nameroute, paramroute) {
      const props = this.$router.resolve({
        name: nameroute,
        query: paramroute,
      });
      // console.log(props);
      return this.baseurl + '' + props.href;
    },
    updateLanguage() {
      this.getBerita();
    },
    getBerita() {
      this.newslist = [];
      this.paramberita.lang = this.$i18n.locale;
      this.paramberita.limit = 6;
      this.paramberita.type = 'berita';
      this.paramberita.category = 'kerjasama';
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pic_berita) {
                  element.urlpic = this.api + '/upload/news/' + element.pic_berita;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.newslist.push(element);
              });
              // console.log(this.newslist);
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
